"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useResizeObserver = void 0;

var react_1 = require("react");

function useResolvedElement(subscriber, refOrElement) {
  var ref = null; // Default ref

  var refElement = (0, react_1.useRef)(null);
  var callbackRefElement = (0, react_1.useRef)(null);
  var refCallback = (0, react_1.useCallback)(function (element) {
    callbackRefElement.current = element;
    callSubscriber();
  }, []);
  var lastReportedElementRef = (0, react_1.useRef)(null);
  var cleanupRef = (0, react_1.useRef)();

  var callSubscriber = function callSubscriber() {
    var element = null;

    if (callbackRefElement.current) {
      element = callbackRefElement.current;
    } else if (refElement.current) {
      element = refElement.current;
    } else if (refOrElement instanceof HTMLElement) {
      element = refOrElement;
    }

    if (lastReportedElementRef.current === element) {
      return;
    }

    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    lastReportedElementRef.current = element;

    if (element) {
      cleanupRef.current = subscriber(element);
    }
  };

  if (refOrElement && !(refOrElement instanceof HTMLElement)) {
    ref = refOrElement;
  }

  (0, react_1.useEffect)(function () {
    if (ref) {
      refElement.current = ref.current;
    }

    callSubscriber();
  }, [ref, ref === null || ref === void 0 ? void 0 : ref.current, refOrElement]);
  return refCallback;
}

function useResizeObserver(opts) {
  if (opts === void 0) {
    opts = {};
  }

  var onResize = opts.onResize;
  var onResizeRef = (0, react_1.useRef)(undefined);
  onResizeRef.current = onResize; // Using a single instance throughout the hook's lifetime

  var resizeObserverRef = (0, react_1.useRef)();

  var _a = __read((0, react_1.useState)({
    width: undefined,
    height: undefined
  }), 2),
      size = _a[0],
      setSize = _a[1];

  var didUnmount = (0, react_1.useRef)(false);
  (0, react_1.useEffect)(function () {
    return function () {
      didUnmount.current = true;
    };
  }, []);
  var previous = (0, react_1.useRef)({
    width: undefined,
    height: undefined
  });
  var refCallback = useResolvedElement(function (element) {
    if (!resizeObserverRef.current) {
      resizeObserverRef.current = new ResizeObserver(function (entries) {
        if (!Array.isArray(entries)) {
          return;
        }

        if (!entries.length) {
          return;
        }

        var entry = entries[0];
        var newWidth = Math.round(entry.contentRect.width);
        var newHeight = Math.round(entry.contentRect.height);

        if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
          var newSize = {
            width: newWidth,
            height: newHeight
          };

          if (onResizeRef.current) {
            onResizeRef.current(newSize);
          } else {
            previous.current.width = newWidth;
            previous.current.height = newHeight;

            if (!didUnmount.current) {
              setSize(newSize);
            }
          }
        }
      });
    }

    resizeObserverRef.current.observe(element);
    return function () {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.unobserve(element);
      }
    };
  }, opts.ref);
  return (0, react_1.useMemo)(function () {
    return {
      ref: refCallback,
      width: size.width,
      height: size.height
    };
  }, [refCallback, size ? size.width : null, size ? size.height : null]);
}

exports.useResizeObserver = useResizeObserver;